import { render, staticRenderFns } from "./VInputDate.vue?vue&type=template&id=2c6e67a2&scoped=true&"
import script from "./VInputDate.vue?vue&type=script&lang=js&"
export * from "./VInputDate.vue?vue&type=script&lang=js&"
import style0 from "./VInputDate.vue?vue&type=style&index=0&id=2c6e67a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6e67a2",
  null
  
)

export default component.exports